import { ActionContext, ActionTree, GetterTree } from "vuex";

const initialState: any = {
//  sknPaymentMethod: -1,
//  sknPaymentDeposit: -1,
  isConfirm: 0,
  loadData: false
};

const actions: ActionTree<any, any> = {
  setPayment({ commit }: ActionContext<any, any>, payload: any): void {
    commit("setPayment", payload);
  },
  confirm({ commit }: ActionContext<any, any>, payload: number): void {
    commit("confirm", payload);
  },
  clearState({ commit }: ActionContext<any, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setPayment(state: any, payload: any) {
    Object.assign(state, { ...payload, loadData: true });
    // 2025/09/19 実質的に使っていない
  },
  confirm(state: any, payload: number) {
    // 1:金額合計確認 2:ネクステージ最低料金確認
    state.isConfirm = payload;
  },
  clearState(state: any) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<any, any> = {
  isConfirm(state: any) {
    // ネクステージで2を扱うので厳密な判定にする
    return ( state.isConfirm == 1? 1 : 0);
  },
  isConfirmNex(state: any) {
    return state.isConfirm;
  },
  loadData(state: any) {
    return state.loadData;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
